import { createTheme, type MantineColorsTuple } from "@mantine/core";

// Primary color - Green as a 10-shade palette
// Used for main brand elements (logo, headings, buttons)
const brand: MantineColorsTuple = [
  "#e8f5e9", // lightest green
  "#c8e6c9", // pale mint
  "#a5d6a7", // very light green
  "#81c784", // soft green
  "#66bb6a", // Main shade - matches the original brand color
  "#4caf50", // classic green
  "#43a047", // vibrant dark green
  "#388e3c", // strong green
  "#2e7d32", // forest green
  "#1b5e20", // darkest green
];

// Secondary color - Orange as a 10-shade palette
// Used for accents, subtitles, and interactive elements (warmth, food appeal)
const accent: MantineColorsTuple = [
  "#fef3e8",
  "#fce6ce",
  "#f9d5a7",
  "#f6c380",
  "#f3b35f",
  "#E79C45", // Main shade - matches the original subtext color
  "#d08a3d",
  "#b87835",
  "#a0662d",
  "#885425",
];

// Neutral color - White/off-white shades for text on dark backgrounds
// Used for body text, descriptions, and general content
const neutral: MantineColorsTuple = [
  "#ffffff", // 0: Pure white
  "#fafafa", // 1: Off-white
  "#f5f5f5", // 2: Light gray
  "#eeeeee", // 3: Slightly darker
  "#e0e0e0", // 4: Medium-light gray
  "#bdbdbd", // 5: Medium gray
  "#9e9e9e", // 6: Gray
  "#757575", // 7: Dark gray
  "#616161", // 8: Darker gray
  "#424242", // 9: Very dark gray
  "#f5f3e6", // 10: creamy beige
  "#e0eb60", // 11: yellow ish
  "#F29B4B", // 12: orange
];

export const theme = createTheme({
  colors: {
    brand,
    accent,
    neutral,
  },
  primaryColor: "brand",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  defaultRadius: "md",
});
